import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { proxyAPI } from "../../proxyAPI";
import { faFolderOpen, faRotate } from "@fortawesome/free-solid-svg-icons";

export default function ProjectsMenu() {
  const [show, setShow] = useState(true);
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [offset, setOffset] = useState(0);
  const [searchParams] = useSearchParams();
  const limit = Number(searchParams.get("limit")) || 10;

  const loadProjects = async (ofs = 0) => {
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `/list-projects?offset=${ofs}&limit=${limit}&status=draft&status=production`,
      setLoading,
    });
    if (ofs === 0) {
      setProjects(data.projects);
    } else {
      setProjects((prev) => [...prev, ...data.projects]);
    }
    setTotal(data.total);
  };

  useEffect(() => {
    loadProjects(offset);
  }, [offset]);

  return (
    <Offcanvas
      show={show}
      onHide={() => setShow(false)}
      onExited={() => navigate("/library/logic/builder")}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <FontAwesomeIcon icon={faFolderOpen} /> Projects
        </Offcanvas.Title>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          type="button"
          className="btn btn-outline-primary border-0 float-end"
          onClick={() => {
            setOffset(0);
            loadProjects();
          }}
        >
          <FontAwesomeIcon icon={faRotate} spin={loading} />
        </button>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {
          // eslint-disable-next-line no-nested-ternary
          projects.length > 0 ? (
            <>
              <ul className="list-group">
                {projects.map((project) => (
                  <li
                    key={project.UUID}
                    className="list-group-item align-items-baseline text-truncate"
                  >
                    <Link
                      to={`/library/logic/builder/${project.ID}`}
                      className="btn btn-link"
                    >
                      {project.Label}{" "}
                    </Link>
                    <span
                      className="text-secondary ms-2"
                      title={project.Description}
                    >
                      {project.Description}
                    </span>
                  </li>
                ))}
              </ul>
              <div className="text-center">
                Total {total} projects found. Showing {projects.length}
              </div>
              {total > projects.length && (
                <div className="text-center">
                  <button
                    type="button"
                    onClick={() => setOffset((prev) => prev + limit)}
                    className="btn btn-link"
                  >
                    Load more
                  </button>
                </div>
              )}
            </>
          ) : (
            !loading && <div className="text-center">No projects to show</div>
          )
        }
      </Offcanvas.Body>
    </Offcanvas>
  );
}
